import pako from 'pako';

export function decompressData(base64Compressed: string): unknown {
  try {
    const binaryString = atob(base64Compressed);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const decompressed = pako.inflate(bytes, { to: 'string' });

    return JSON.parse(decompressed);
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
}
